(function ($) {
    $(document).ready(function () {
        blockCollapse();
    });

    function blockCollapse() {
        let activeElem = false;

        $('.block-collapse .collapse-item .collapse-item__title').each(function(){
            let parent = $(this).parent();

            $(this).on('click', function(){
                if(parent.hasClass('collapse-item--active')){
                    activeElem = $(this);
                    parent.removeClass('collapse-item--active');
                }
                else {
                    scrollCollapse($(this));
                    activeElem = false;
                    $('.block-collapse .collapse-item').each(function(){
                        $(this).removeClass('collapse-item--active');
                    })
                    parent.addClass('collapse-item--active');
                }
            });
        })
    }

    function scrollCollapse(elem) {
        let activeItem = $('.block-collapse .collapse-item.active'),
            height = activeItem.find('.collapse-item__content').height(),
            offset = $(elem).offset().top;

        if(height && $(elem).closest('.collapse-item').data('key') > activeItem.data('key')) {
            offset = offset - height - 20;
        }

        $('html, body').stop().animate({scrollTop: offset}, 200);
    }
})(jQuery);